import { render, staticRenderFns } from "./CommonErrorComponent.vue?vue&type=template&id=95f79842&"
import script from "./CommonErrorComponent.vue?vue&type=script&lang=js&"
export * from "./CommonErrorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports